module.exports = {"httpsHost":"https://backend:8843/paytron/api/v1","httpHost":"http://backend:8081/paytron/api/v1/","sslEnabled":false,"displayDateFormat":"dd/MM/yyyy","displayTimeFormat":"HH:mm","posCodeId":"REC","datepickerConfig":{"containerClass":"theme-dark-blue","dateInputFormat":"DD/MM/YYYY"},"modalConfig":{"ignoreBackdropClick":true,"keyboard":false},"cardReaderWebSocketUrl":"ws://localhost:8082/rfid","helpHref":"https://www.metweb.it/MetpayManuali.html","version":"0.2.2"}


//////////////////
// WEBPACK FOOTER
// ./src/providers/config/config.json
// module id = 905
// module chunks = 0